import { Radio as MantineRadio, RadioProps } from '@mantine/core';

export type IRadioProps = RadioProps;

/** @registry Design-layer pass-through over Mantine Radio; import this instead of @mantine/core Radio outside src/design. Extend here when Radio needs house behavior. Compound statics (Radio.Group, Radio.Card, ...) are preserved. */
export const Radio = MantineRadio;
